
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"currentColor"}},[_c('circle',{attrs:{"cx":"25","cy":"25","r":"24","stroke-width":"2"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-width":"4","d":"M17 25.687l4.582 6.654c.328.476.886.49 1.239.04L34.5 17.5"}})])])
          )
        }
      }
    